exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea{resize:vertical}a{text-decoration:none}a:hover{color:#4d90fe}a:focus{outline:none}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.container,body,html{min-width:970px!important}.page-header{margin-top:15px;margin-bottom:10px}.d-flex{display:flex;flex-wrap:wrap}.biu-instance{z-index:10000!important}.vertical-sub{vertical-align:sub}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/common.css
 ** module id = 604
 ** module chunks = 2
 **/